import * as types from './yarnActionTypes';

export const getYarnRequestAction = (payload) => ({
  type: types.GET_YARN_REQUEST,
  payload,
});

export const getYarnDataAction = (payload) => ({
  type: types.GET_YARN_DATA,
  payload,
});

export const getYarnErrorAction = (payload) => ({
  type: types.GET_YARN_ERROR,
  payload,
});

export const createYarnRequestAction = (payload) => ({
  type: types.CREATE_YARN_REQUEST,
  payload,
});

export const createYarnDataAction = (payload) => ({
  type: types.CREATE_YARN_DATA,
  payload,
});

export const createYarnErrorAction = (payload) => ({
  type: types.CREATE_YARN_ERROR,
  payload,
});

export const updateYarnRequestAction = (payload) => ({
  type: types.UPDATE_YARN_REQUEST,
  payload,
});

export const updateYarnDataAction = (payload) => ({
  type: types.UPDATE_YARN_DATA,
  payload,
});

export const updateYarnErrorAction = (payload) => ({
  type: types.UPDATE_YARN_ERROR,
  payload,
});

export const deleteYarnRequestAction = (payload) => ({
  type: types.DELETE_YARN_REQUEST,
  payload,
});

export const deleteYarnDataAction = (payload) => ({
  type: types.DELETE_YARN_DATA,
  payload,
});

export const deleteYarnErrorAction = (payload) => ({
  type: types.DELETE_YARN_ERROR,
  payload,
});
